const es: Record<string, string> = {
  // ── Navegación ──
  nav_home: 'Inicio',
  nav_shop: 'Tienda',
  nav_blueProtect: 'Blue Protect',
  nav_evilEnergy: 'Evil Energy',
  nav_destroyKit: 'Destroy Kit',
  nav_consultations: 'Consultas',
  nav_blog: 'Blog',
  nav_about: 'Nosotros',
  nav_contact: 'Contacto',
  nav_bookConsult: 'Reservar Consulta',
  nav_myOrders: 'Mis Pedidos',

  // ── Hero ──
  hero_badge: 'Arraigado en el Chamanismo · Más Antiguo que el Tiempo',
  hero_title1: 'Eleva Tu',
  hero_title2: 'Energía',
  hero_shamBadge: '✦ Chamanismo ✦',
  hero_shamLabel: 'El Chamanismo',
  hero_shamDesc: 'es una de las prácticas espirituales más antiguas del mundo, con raíces en tradiciones y culturas indígenas de todo el mundo — la fuente de todos nuestros rituales.',
  hero_subtitle: 'Productos espirituales premium, limpiezas de energía y consultas personales. Basado en miles de años de conocimiento de protección chamánica.',
  hero_shopNow: 'Comprar Ahora',
  hero_discoverCollection: 'Descubrir Colección',

  // ── Insignias de confianza ──
  trust_worldwide: 'Envío Mundial',
  trust_quality: 'Calidad Premium',
  trust_guarantee: 'Garantía 30 Días',
  trust_payment: 'Pago Seguro',

  // ── Footer ──
  footer_followText: 'Síguenos para inspiración diaria del mundo del',
  footer_shamanism: 'chamanismo',
  footer_followEnd: 'y protección espiritual',
  footer_brandDesc: 'Arraigado en el chamanismo — una de las prácticas espirituales más antiguas del mundo. Rituales de protección auténticos, herramientas sagradas y consultas personales para todos los que desean elevar su conciencia.',
  footer_shopTitle: 'Tienda',
  footer_infoTitle: 'Información',
  footer_newsletterTitle: 'Boletín',
  footer_newsletterDesc: 'Recibe consejos espirituales, ofertas exclusivas y nuevos rituales.',
  footer_newsletterPlaceholder: 'tu@email.com',
  footer_newsletterBtn: 'Suscribirse',
  footer_copyright: '© 2026 ZpiritualZ. Todos los derechos reservados.',
  footer_privacy: 'Política de Privacidad',
  footer_terms: 'Términos y Condiciones',
  footer_cookies: 'Cookies',
  footer_ship_worldwide: 'Envío Mundial',
  footer_ship_worldwide_sub: 'Enviamos a todos los países',
  footer_ship_fast: 'Procesamiento Rápido',
  footer_ship_fast_sub: 'Pedido enviado rápidamente',
  footer_ship_discreet: 'Embalaje Discreto',
  footer_ship_discreet_sub: 'Sin etiquetado llamativo',
  footer_ship_contact: 'Contacto Personal',
  footer_ship_contact_sub: 'Siempre disponible por WhatsApp',

  // ── Footer links ──
  footer_link_blueProtect: 'Serie Blue Protect',
  footer_link_crystals: 'Cristales y Piedras Preciosas',
  footer_link_aroma: 'Aromaterapia',
  footer_link_chakra: 'Sanación de Chakras',
  footer_link_supp: 'Suplementos',
  footer_link_selfcare: 'Autocuidado',
  footer_link_about: 'Nosotros',
  footer_link_blog: 'Blog',
  footer_link_consult: 'Reservar Consulta',
  footer_link_reviews: 'Reseñas y Experiencias',
  footer_link_faq: 'Preguntas Frecuentes (FAQ)',
  footer_link_orders: 'Mis Pedidos',
  footer_link_contact: 'Contacto',
  footer_link_shipping: 'Envíos y Devoluciones',

  // ── Idioma ──
  lang_nl: 'Nederlands',
  lang_en: 'English',
  lang_es: 'Español',

  // ── CTAs ──
  cta_planConsult: 'Reservar consulta',
  cta_bookConsult: 'Reservar Consulta',
  cta_discoverProtection: 'Descubre tu protección',
  cta_allProducts: 'Ver todos los productos de protección',
  cta_startToday: 'Empieza hoy',
  cta_viewProduct: 'Ver',
  cta_buyNow: 'Pagar y Reservar',
  cta_learnMore: 'Más información',
  cta_shopNow: 'Comprar Ahora',
  cta_readMore: 'Leer más',
  cta_back: 'Atrás',
  cta_subscribe: 'Suscribirse',
  cta_bookNow: 'Reservar Ahora',
  cta_allArticles: 'Todos los artículos',
  cta_chooseProduct: 'Elige tu Producto',
  cta_askAdvice: 'Pedir Consejo',
  cta_discoverSeries: 'Descubrir la Serie',
  cta_inCart: 'Agregar al Carrito',
  cta_addToCart: 'Agregar al Carrito',
  cta_added: 'Agregado',
  cta_add: 'Agregar',
  cta_viewAllProducts: 'Ver todos los productos',
  cta_bookConsultNow: 'Reserva Tu Consulta',
  cta_sendMessage: 'Enviar Mensaje',
  cta_sending: 'Enviando...',
  cta_newMessage: 'Nuevo Mensaje',
  cta_backToConsult: 'Volver a Consultas',
  cta_inCartBtn: '¡En el carrito!',
  cta_addToCartBtn: 'Al Carrito',

  // ── Tienda ──
  shop_title: 'Nuestra Colección',
  shop_webshop_title: 'Blue Protect',
  shop_webshop_subtitle: 'Productos exclusivos de protección Blue Protect',
  shop_filter_all: 'Todos los Productos',
  shop_filter_blue: 'Serie Blue Protect',
  shop_filter_evil: 'Evil Energy Destroy',
  shop_filter_kit: 'Evil Energy Destroy Kit',
  shop_addToCart: 'Agregar al Carrito',
  shop_inStock: 'En Stock',
  shop_outOfStock: 'Agotado',
  shop_perUnit: 'único',
  shop_reviews: 'reseñas',
  shop_search_placeholder: 'Buscar productos...',
  shop_sort_featured: 'Destacados',
  shop_sort_price_asc: 'Precio: Menor a Mayor',
  shop_sort_price_desc: 'Precio: Mayor a Menor',
  shop_sort_rating: 'Mayor Valoración',
  shop_categories: 'Categorías',
  shop_max_price: 'Precio Máximo',
  shop_products_found: 'productos encontrados',
  shop_no_products: 'No se encontraron productos',
  shop_cancelled_title: 'Pago cancelado',
  shop_cancelled_msg: 'Cancelaste el pago. Tu carrito se ha guardado — puedes intentarlo de nuevo en cualquier momento.',
  shop_blue_desc: 'Limpieza de aura y protección espiritual — jabón, bolas, polvo y spray.',
  shop_evil_desc: 'La protección más fuerte contra energías malignas, mal de ojo y ataques espirituales.',
  shop_kit_desc: 'Kit completo de bricolaje para casos extremos — bebés, nuevos espacios y entidades.',

  // ── Consultas ──
  consult_hero_badge: '✦ Orientación Personal ✦',
  consult_hero_title: 'Consultas',
  consult_hero_title2: 'Espirituales',
  consult_hero_sub: 'Orientación energética personal y planos de rituales digitales para una transformación espiritual profunda.',
  consult_tab_book: 'Reservar Consulta',
  consult_tab_blueprints: 'Planos de Rituales',
  consult_choose: 'Elige Tu Consulta',
  consult_payment_title: 'Cita y Pago',
  consult_form_first: 'Nombre',
  consult_form_last: 'Apellido',
  consult_form_email: 'Correo Electrónico',
  consult_form_phone: 'Número de Teléfono',
  consult_form_date: 'Fecha Preferida',
  consult_form_date_ph: 'Elige una fecha',
  consult_form_time: 'Preferencia de Horario',
  consult_form_msg: 'Tu pregunta o situación',
  consult_form_msg_ph: 'Describe brevemente lo que esperas descubrir o lograr...',
  consult_book_btn: 'Pagar y Reservar',
  consult_success_title: '¡Pago Exitoso!',
  consult_success_msg: 'Recibirás un correo de confirmación en unos minutos. Nos pondremos en contacto para programar la cita.',
  consult_back: 'Volver a Consultas',
  consult_stripe_info: 'Pago seguro con Stripe',
  consult_stripe_desc: 'Paga directamente con tarjeta de crédito o iDEAL. Recibirás una confirmación por correo después del pago.',
  consult_ssl: 'SSL 256 bits',
  consult_stripe_footer: 'Pago seguro via Stripe · tarjeta de crédito e iDEAL',
  consult_select_first: 'Selecciona un tipo de consulta arriba',
  consult_selected: 'Seleccionado',
  consult_most_chosen: 'Más Popular',
  consult_once: 'único',
  consult_add_cart: 'Agregar al Carrito',
  consult_cart_safe: 'Pago en carrito · pago seguro con Stripe',
  consult_avail_hint: 'Disponible los',
  consult_avail_and: 'y',
  consult_no_avail: 'Sin disponibilidad',
  consult_no_avail_msg: 'No hay consultas este día. Elige un lunes o jueves.',
  consult_choose_date_first: 'Elige primero una fecha para ver los horarios disponibles',
  consult_digital_guides: '✦ Guías Digitales ✦',
  consult_blueprints_title: 'Planos de Rituales',
  consult_blueprints_sub: 'Guías digitales completas para rituales de limpieza espiritual. Descarga instantánea tras la compra vía Stripe.',
  consult_stripe_safe: 'Pago seguro con Stripe',
  consult_stripe_safe_desc: 'Tras el pago recibirás inmediatamente un enlace de descarga por correo. Disponible con tarjeta de crédito e iDEAL.',
  consult_digital_guide: 'Guía Digital',
  consult_more_included: 'más incluido',
  consult_download_title: 'Descarga Instantánea Tras el Pago',
  consult_download_desc: 'Tras el pago exitoso vía Stripe recibirás inmediatamente un correo con tu enlace de descarga. Los planos están en formato PDF y son accesibles de por vida.',
  consult_payment_success: '¡Pago exitoso!',
  consult_payment_success_desc: 'Tu enlace de descarga ha sido enviado a tu correo. Revisa también tu carpeta de spam.',
  consult_reviews_badge: '✦ Experiencias ✦',
  consult_reviews_title: 'Lo que Dicen',
  consult_reviews_title2: 'los Clientes',
  consult_reviews_sub: 'Experiencias reales de personas que dieron el paso hacia una consulta. Sin guiones, sin filtros.',
  consult_avg_rating: 'Valoración media',
  consult_reviews_count: 'Valoraciones',
  consult_recommend: 'Lo recomendaría',
  consult_ready: '¿Listo para crear tu propia experiencia?',

  // ── Blog ──
  blog_hero_badge: '✦ Chamanismo y Conocimiento Espiritual ✦',
  blog_hero_title: 'Protección para Ti,',
  blog_hero_title2: 'Tu Hijo y Tu Entorno',
  blog_hero_sub: 'Inquietud, pérdida de energía, un bebé que se despierta por la noche — a veces hay más de lo que puedes ver. Descubre el conocimiento de protección chamánica para familia, hogar y trabajo.',
  blog_sticky_cta: 'Reservar consulta',
  blog_recognize_badge: '✦ ¿Te identificas con esto? ✦',
  blog_recognize_title: 'A veces hay más de lo que puedes explicar',
  blog_more: '¿Leer más?',
  blog_read_time: 'de lectura',

  // ── Sobre Nosotros ──
  about_badge: '✦ Nuestra Historia ✦',
  about_title: 'Arraigado en',
  about_title2: 'Tradiciones Chamánicas',
  about_sub: 'Orientación personal, rituales de protección auténticos y conocimiento milenario — para todos los que desean elevar su conciencia.',

  // ── Contacto ──
  contact_badge: '✦ Ponte en Contacto ✦',
  contact_title: 'Contacto',
  contact_sub: '¿Tienes una pregunta o quieres saber más? Estamos aquí para ti.',
  contact_info_title: 'Información de Contacto',
  contact_social_title: 'Síguenos en Redes Sociales',
  contact_form_title: 'Enviar un Mensaje',
  contact_form_first: 'Nombre *',
  contact_form_last: 'Apellido *',
  contact_form_email: 'Correo Electrónico *',
  contact_form_subject: 'Asunto *',
  contact_form_subject_ph: 'Selecciona un asunto',
  contact_form_subject_product: 'Pregunta sobre producto',
  contact_form_subject_order: 'Pedido / Envío',
  contact_form_subject_consult: 'Información de consulta',
  contact_form_subject_collab: 'Colaboración',
  contact_form_subject_other: 'Otro',
  contact_form_msg: 'Tu mensaje *',
  contact_form_msg_ph: '¿Cómo podemos ayudarte?',
  contact_form_max: 'Máx. 500 caracteres',
  contact_success_title: '¡Mensaje Enviado!',
  contact_success_msg: 'Gracias por tu mensaje. Responderemos lo antes posible.',
  contact_error: 'Algo salió mal. Por favor inténtalo de nuevo.',

  // ── FAQ ──
  faq_badge: 'Preguntas Frecuentes',
  faq_title: 'Todo lo que quieres',
  faq_title2: 'saber',
  faq_sub: 'Respuestas a las preguntas más frecuentes sobre nuestros productos, rituales, pedidos y protección espiritual.',
  faq_questions_answered: 'Preguntas respondidas',
  faq_categories: 'Categorías',
  faq_available: 'Disponible',
  faq_questions_in_cat: 'preguntas en esta categoría',
  faq_not_found_title: '¿No encuentras tu pregunta?',
  faq_not_found_desc: 'Contáctanos directamente por correo o reserva una consulta personal — estaremos encantados de ayudarte.',
  faq_send_message: 'Enviar un mensaje',
  faq_book_consult: 'Reservar una consulta',

  // ── Home - FeaturedProducts ──
  home_bestsellers_badge: '✦ Más Vendidos ✦',
  home_bestsellers_title: 'Más Vendidos',

  // ── Home - SeriesSection ──
  home_series_badge: '✦ Nuestras Series ✦',
  home_series_title: 'Elige Tu',
  home_series_title2: 'Protección',
  home_series_sub: 'Dos series, cada una para una situación diferente. Desde la prevención diaria hasta la máxima protección contra ataques espirituales intensos.',
  home_series_products: 'productos',
  home_series_reviews: 'reseñas',
  home_series_not_sure: '¿No sabes qué serie te conviene?',
  home_series_free_consult: 'Reserva una consulta gratuita',
  home_series_help: 'y te ayudamos a elegir.',

  // ── Home - CTASection ──
  home_cta_discover_badge: '✦ Descúbrete ✦',
  home_cta_discover_title: 'Encuentra Tu Equilibrio Interior',
  home_cta_discover_sub: 'Armoniza cuerpo y mente',
  home_cta_blueprint_badge: '✦ Plan de Crecimiento Personal ✦',
  home_cta_blueprint_title: 'Tu Plano',
  home_cta_blueprint_title2: 'Espiritual',
  home_cta_blueprint_sub: 'Reserva una consulta personal o descarga nuestros planos de rituales digitales y comienza hoy a transformar tu vida energética.',
  home_cta_book_consult: 'Reservar una Consulta Ahora',
  home_cta_blueprints: 'Planos de Rituales',

  // ── Home - TestimonialsSection ──
  home_test_badge: '✦ Experiencias ✦',
  home_test_title: 'Lo que Dicen los Clientes sobre',
  home_test_sub: 'Experiencias reales de clientes que experimentan a diario el poder del extracto azul puro de nuestra tradición ancestral.',
  home_test_stat1: 'Clientes satisfechos',
  home_test_stat2: 'Valoración media',
  home_test_stat3: 'Compras repetidas',
  home_test_stat4: 'Años de tradición',

  // ── Home - FeaturedCategories ──
  home_cat_badge: '✦ Colecciones ✦',
  home_cat_title: 'Descubre Nuestras',
  home_cat_title2: 'Colecciones',
  home_cat_new: 'Nuevo',

  // ── Home - BlogPreview ──
  home_blog_badge: '✦ Blog ✦',
  home_blog_title: 'Perspectivas',
  home_blog_title2: 'Espirituales',

  // ── Home - InstagramSection ──
  home_insta_title: 'Síguenos en',
  home_insta_title2: 'Instagram',
  home_insta_sub: 'Rituales diarios, consejos de productos e inspiración espiritual. Etiquétanos con',
  home_insta_sub2: '¡y aparece en nuestra página!',
  home_insta_hashtags_title: 'Usa estos hashtags',
  home_insta_hashtags_sub: '— amplía tu alcance',
  home_insta_copy_all: 'Copiar todos los hashtags',
  home_insta_copied: '¡Todos copiados!',
  home_insta_copied_tag: '¡Copiado!',
  home_insta_follow: 'Seguir @zpiritualz',
  home_insta_ugc: 'clientes compartieron su experiencia — ¡etiquétanos y aparece en nuestra página!',

  // ── Home - TikTokSection ──
  home_tiktok_title: 'Síguenos en',
  home_tiktok_title2: 'TikTok',
  home_tiktok_sub: 'Rituales diarios, demos de productos y consejos espirituales. Únete a nuestra creciente comunidad de',
  home_tiktok_sub2: 'seguidores que protegen su energía.',
  home_tiktok_followers: 'Seguidores',
  home_tiktok_likes: 'Me gusta',
  home_tiktok_views: 'Vistas',
  home_tiktok_no_miss: 'No te pierdas ningún ritual',
  home_tiktok_no_miss_sub: 'Nuevos videos cada semana sobre protección espiritual, demos de productos y rituales. ¡Síguenos ahora y activa las notificaciones!',
  home_tiktok_follow: 'Seguir @zpiritualz.com',
  home_tiktok_notify: 'Activar notificaciones',

  // ── Blue Protect página ──
  bp_cultural_badge: '✦ Origen y Cultura ✦',
  bp_cultural_title: 'Uso ancestral,',
  bp_cultural_title2: 'forma moderna',
  bp_cultural_desc1: 'El polvo azul se ha utilizado durante miles de años en culturas surinamesas y de todo el mundo para protección contra el mal de ojo — Ogri Ai en surinamés, Nazar entre los hindustaníes, Azul en la tradición española.',
  bp_cultural_desc2: 'Blue Protect preserva este patrimonio en su forma más pura. El extracto de índigo se obtiene exactamente como lo hacían nuestros antepasados — a mano, sin pasos de procesamiento químico, con respeto por la tradición.',
  bp_heritage: 'Herencia Surinamesa',
  bp_test_badge: '✦ Experiencias ✦',
  bp_test_title: 'Lo que Dicen',
  bp_test_title2: 'los Clientes',
  bp_cross_badge: 'Para casos más graves',
  bp_cross_title: 'También descubre la',
  bp_cross_title2: 'Serie Evil Energy Destroy',
  bp_cross_title3: '?',
  bp_cross_desc: 'Para ataques espirituales intensos, energías malignas persistentes o exposición repetida — la Serie Evil Energy Destroy es nuestra fórmula más poderosa.',
  bp_cross_btn: 'Ver Evil Energy Protect',
  bp_cta_badge: '✦ Empieza Hoy ✦',
  bp_cta_title: 'Tu Protección',
  bp_cta_title2: 'Comienza Aquí',
  bp_cta_sub: 'Entra en una tradición de protección ancestral. Puro, auténtico y poderoso — exactamente como nuestros antepasados lo concibieron.',
  bp_cta_choose: 'Elige tu Producto',
  bp_cta_advice: 'Pedir Consejo',
  bp_cta_pure: '100% Extracto de Índigo Puro',
  bp_cta_fast: 'Envío Rápido',
  bp_cta_safe: 'Pedido Seguro',
  bp_nav_products: 'Productos',
  bp_nav_rituals: 'Rituales',
  bp_nav_ingredients: 'Ingredientes',

  // ── Evil Energy página ──
  ee_test_badge: '✦ Experiencias ✦',
  ee_test_title: 'Lo que Dicen',
  ee_test_title2: 'los Clientes',
  ee_cta_badge: '✦ Listo para la Protección ✦',
  ee_cta_title: 'Tu Protección',
  ee_cta_title2: 'Comienza Hoy',
  ee_cta_sub: 'No esperes a que la situación empeore. La Serie Evil Energy Destroy está lista para protegerte con el poder de las tradiciones ancestrales y los ingredientes más puros.',
  ee_cta_choose: 'Elige tu Producto',
  ee_cta_advice: 'Pedir Consejo',
  ee_cta_pure: '100% Natural Puro',
  ee_cta_fast: 'Envío Rápido',
  ee_cta_safe: 'Pedido Seguro',
  ee_nav_products: 'Productos',
  ee_nav_bundle: 'Paquete Ritual',
  ee_nav_rituals: 'Rituales',
  ee_nav_ingredients: 'Ingredientes',

  // ── Sobre Nosotros ──
  about_hero_title: 'El Poder Detrás de ZpiritualZ',
  about_founded: 'Fundado',
  about_tradition: 'Años de tradición',
  about_households: 'Hogares protegidos',
  about_story_badge: '✦ Cómo Empezó ✦',
  about_story_title: 'Una Experiencia Personal Que Lo Cambió Todo',
  about_story_p1: 'ZpiritualZ no nació de una hoja de cálculo ni de un plan de marketing — nació de una crisis personal. Tras un período de negatividad persistente, inquietud en el hogar y la sensación de que algo no estaba bien en la energía del entorno, la fundadora volvió a lo que su abuela le había enseñado: quemar hing, hing bajo la almohada, hing en el agua del baño.',
  about_story_p2: 'El cambio fue palpable. No como magia — sino como reconocimiento. Como volver a casa con un conocimiento que siempre había estado presente en la familia, pero que se había transmitido durante generaciones sin explicación. ZpiritualZ fue fundada para devolver ese conocimiento a todos los que lo necesitan.',
  about_story_p3: 'Hoy traducimos antiguas tradiciones de protección chamánica en productos que encajan en la vida diaria: en el baño, en el dormitorio, en la habitación del bebé — en todos los lugares donde se necesita protección.',
  about_ingredient_label: 'Ingrediente Clave',
  about_ingredient_name: 'Ferula asafoetida',
  about_ingredient_sub: 'Extracto puro de hing · Iraní e Indio',
  about_sham_origin: '✦ El Origen de Todo ✦',
  about_sham_title: 'El Chamanismo es la Fuente',
  about_sham_desc: 'El chamanismo es una de las prácticas espirituales más antiguas del mundo, con raíces en tradiciones y culturas indígenas de todo el mundo. Los chamanes son los constructores de puentes entre el mundo visible e invisible — los protectores, sanadores y guías de su comunidad.',
  about_sham_worldwide: 'Presente en todo el mundo',
  about_sham_worldwide_desc: 'Desde Siberia hasta el Amazonas, desde África Occidental hasta Oceanía — el chamanismo es el lenguaje espiritual universal de la humanidad.',
  about_sham_age: 'Más de 40.000 años',
  about_sham_age_desc: 'Más antiguo que todas las religiones organizadas. Las raíces del chamanismo se remontan a los primeros humanos que encendieron fuego y estudiaron las estrellas.',
  about_sham_plants: 'Las plantas como clave',
  about_sham_plants_desc: 'Plantas sagradas y resinas — como el hing, la salvia y el lobhan — son los instrumentos del chamán para la purificación, protección y sanación.',
  about_sham_caption: 'Chamanismo · Sabiduría Global',
  about_sham_caption_sub: 'Cada cultura, cada continente — el chamán está universalmente presente como protector de la comunidad.',
  about_hing_badge: '✦ El Origen ✦',
  about_hing_title: 'La Tradición del Hing: 2.000 Años de Protección',
  about_hing_sub: 'El hing — la resina de la planta Ferula asafoetida — es una de las materias primas espirituales y medicinales más antiguas del mundo. De Irán a India, de India a Surinam, de Surinam a los Países Bajos.',
  about_hing_origin: 'Procedente de Irán e India',
  about_hing_origin_desc: 'La Ferula asafoetida crece en los desiertos de Asia Central. La resina se ha utilizado durante más de 2.000 años en tradiciones persas, indias y surinamesas.',
  about_hing_protector: 'Protector del Hogar',
  about_hing_protector_desc: 'En los hogares hindustaníes, el hing se ha utilizado durante generaciones para proteger el hogar, el bebé y el dormitorio contra el mal de ojo y las energías negativas.',
  about_hing_smoke: 'Purificado por el Humo',
  about_hing_smoke_desc: 'Quemar hing como incienso purifica la energía de un espacio. El aroma penetra en cada rincón y expulsa lo que no pertenece al espacio.',
  about_hing_baby: 'Protección del Bebé',
  about_hing_baby_desc: 'Durante siglos, la pasta de hing se ha aplicado en el cabello de los recién nacidos o se ha colocado bajo la almohada — un ritual amoroso transmitido de madre a hijo.',
  about_hing_quote: '"El hing nunca se pierde — viaja. Desde las tierras altas indias hasta las sabanas surinamesas, desde las sabanas hasta los barrios holandeses. El conocimiento vive."',
  about_hing_journey: 'El Viaje del Hing por el Mundo',
  about_timeline_badge: '✦ Línea de Tiempo ✦',
  about_timeline_title: 'De la Tradición Ancestral a la Marca Moderna',
  about_philosophy_badge: '✦ Filosofía ✦',
  about_philosophy_title: 'Lo Que Creemos',
  about_philosophy_sub: 'ZpiritualZ es más que una línea de productos — es una filosofía de protección, conciencia y patrimonio cultural.',
  about_phil_roots: 'Respetar las Raíces',
  about_phil_roots_desc: 'Nuestros productos no fueron inventados — fueron redescubiertos. Traemos la sabiduría de los ancestros de vuelta al mundo moderno sin perder la esencia.',
  about_phil_pure: 'Puro y Sin Diluir',
  about_phil_pure_desc: 'Sin rellenos baratos. Sin máscaras sintéticas. Cada producto contiene un porcentaje justo de extracto puro de hing, como prescribe la tradición.',
  about_phil_sham: 'Conocimiento Chamánico',
  about_phil_sham_desc: 'El chamanismo es una de las prácticas espirituales más antiguas del mundo — arraigado en tradiciones y culturas indígenas de todo el mundo. ZpiritualZ bebe de esta fuente atemporal.',
  about_phil_ritual: 'Rituales para Todos',
  about_phil_ritual_desc: 'Ya seas una nueva madre, estés buscando limpieza del hogar o simplemente quieras protección — nuestros productos son accesibles y prácticos para el uso diario.',
  about_quote: '"Cada producto que hacemos es una oración. Un recordatorio de lo que sabían nuestros ancestros: que la protección comienza con el aroma, con la intención, con el ritual."',
  about_cta_badge: '✦ Descubre los Productos ✦',
  about_cta_title: '¿Listo para Proteger Tu Hogar?',
  about_cta_sub: 'Descubre nuestra Serie Evil Energy Destroy — seis productos basados en extracto puro de hing, para protección diaria en casa, para el bebé y para el espacio.',
  about_cta_ee: 'Serie Evil Energy Destroy',
  about_cta_shop: 'Todos los Productos',

  // ── Contacto ──
  contact_address: 'Dirección',
  contact_email_label: 'Correo',
  contact_hours: 'Horario',
  contact_reach: 'Disponibilidad',
  contact_address_val: 'Kobaltstraat 21, 2544 ET La Haya, Países Bajos',
  contact_email_val: 'info@zpiritualz.com',
  contact_hours_val: 'Lun–Sáb: 10:00–17:00',
  contact_reach_val: 'Solo somos accesibles por correo electrónico',
  contact_map_title: 'Ubicación ZpiritualZ La Haya',
  contact_form_ph_first: 'Luna',
  contact_form_ph_last: 'García',
  contact_form_ph_email: 'tu@email.com',
  contact_form_ph_msg: '¿Cómo podemos ayudarte?',

  // ── FAQ ──
  faq_cat_general: 'General',
  faq_cat_blue: 'Serie Blue Protect',
  faq_cat_evil: 'Serie Evil Energy Destroy',
  faq_cat_kit: 'Evil Energy Destroy Kit',
  faq_cat_blueprints: 'Planos de Rituales',
  faq_cat_consult: 'Consultas',
  faq_questions_in_cat_label: 'preguntas en esta categoría',

  // ── Tienda ──
  shop_hero_title: 'Blue Protect',
  shop_hero_subtitle: 'Tienda Online',
  shop_hero_desc: 'Productos exclusivos de protección Blue Protect',
  shop_filter_label: 'Categorías',
  shop_price_label: 'Precio Máximo',
  shop_in_stock: 'En stock',
  shop_cancelled_close: 'Cerrar',

  // ── Blue Protect Hero ──
  bp_hero_badge: 'Protección Ancestral',
  bp_hero_title: 'Serie Blue Protect',
  bp_hero_sub: 'Basado en el uso ancestral del polvo azul para la protección espiritual — arraigado en la cultura surinamesa y reconocido en todo el mundo.',
  bp_hero_pure: 'Extracto de índigo puro, exactamente como lo usaban nuestros ancestros. Sin aditivos sintéticos. Nunca.',
  bp_hero_surinamese: 'Surinamés',
  bp_hero_hindustani: 'Hindustaní',
  bp_hero_spanish: 'Español',
  bp_hero_view_products: 'Ver Productos',
  bp_hero_discover: 'Descubrir la Fórmula',
  bp_hero_stat1: 'Productos en la Serie',
  bp_hero_stat2: 'Valoración Media',
  bp_hero_stat3: 'Reseñas de Clientes',
  bp_hero_stat4: 'Extracto de Índigo Puro',

  // ── Blue Protect Ingredientes ──
  bp_ing_badge: '✦ Puro de la Naturaleza ✦',
  bp_ing_title: 'Los Ingredientes',
  bp_ing_sub: 'Cada ingrediente de la Serie Blue Protect se obtiene puramente de la naturaleza — exactamente como lo usaban nuestros ancestros durante siglos, sin procesos químicos.',
  bp_ing_promise_badge: 'Nuestra Promesa',
  bp_ing_promise_title: 'Solo extracto de índigo puro. Sin imitaciones sintéticas. Nunca.',
  bp_ing_promise_desc: 'Muchos competidores usan tintes azules sintéticos como alternativa barata. Nosotros nos negamos. Nuestro azul proviene exclusivamente de la planta índigo — tal como se obtiene en la fuente.',
  bp_ing_name: 'Extracto de Índigo Puro',
  bp_ing_latin: 'Indigofera tinctoria',
  bp_ing_desc: 'El corazón de la fórmula Blue Protect. La indigofera es una planta sagrada que se ha utilizado durante miles de años en rituales de protección espiritual en todo el mundo. El extracto azul profundo se obtiene directamente de la planta — puro, sin filtrar y sin procesar.',
  bp_ing_origin: 'Asia del Sur y África Occidental — el tinte protector más antiguo conocido del mundo',
  bp_ing_found_in: 'Presente en todos los productos',
  bp_ing_balls_badge: '✦ Característica Única ✦',
  bp_ing_balls_title: 'Blue Protect Balls — Disolver es el Poder',
  bp_ing_balls_sub: 'Lo que hace únicas a las Balls en comparación con los otros productos de la serie: están especialmente hechas para disolverse en agua. Esto libera el extracto completamente — en el baño o como vaso protector en las esquinas de tu espacio.',
  bp_ing_balls_f1_title: 'Se disuelve completamente en agua',
  bp_ing_balls_f1_desc: 'La bola se disuelve lentamente y libera gradualmente el extracto de índigo puro — en el baño o en un vaso de agua.',
  bp_ing_balls_f2_title: 'Vaso de agua en las esquinas',
  bp_ing_balls_f2_desc: 'Coloca una bola disuelta en un vaso de agua con un chorrito de Evil Energy Destroy Cologne y colócalo en las esquinas de las habitaciones para protección constante.',
  bp_ing_balls_f3_title: 'Limpieza profunda de baño',
  bp_ing_balls_f3_desc: 'Disuelve una bola en agua de baño caliente para una limpieza energética profunda de todo el cuerpo — el extracto se distribuye uniformemente por el agua.',
  bp_ing_balls_f4_title: '100% puro y natural',
  bp_ing_balls_f4_desc: 'Sin aglutinantes ni rellenos sintéticos — la bola consiste exclusivamente en extracto de índigo puro que se disuelve completamente sin residuos.',
  bp_ing_how_badge: 'Cómo funciona',
  bp_ing_how_title: 'En cuanto la bola entra en contacto con el agua, el extracto de índigo comienza a liberarse — el agua se vuelve azul profundo y está lista para usar.',
  bp_ing_how_f1: 'Completamente soluble — sin residuos',
  bp_ing_how_f2: 'Funciona en el baño y en un vaso de agua',
  bp_ing_how_f3: 'Combinar con Evil Energy Destroy Cologne',

  // ── Blue Protect Productos ──
  bp_prod_badge: '✦ La Colección ✦',
  bp_prod_title: '4 Productos, 1 Misión',
  bp_prod_sub: 'Cada fórmula de la Serie Blue Protect está orientada a un método de aplicación específico — juntas forman una capa completa de protección espiritual.',
  bp_prod_series: 'Serie Blue Protect',
  bp_prod_in_stock: 'En stock',
  bp_prod_tab_desc: 'Descripción',
  bp_prod_tab_ing: 'Ingredientes',
  bp_prod_tab_use: 'Cómo Usar',
  bp_prod_tab_reviews: 'Reseñas',
  bp_prod_ing_title: 'Ingredientes',
  bp_prod_ing_pure: 'Todos los ingredientes son 100% puros en origen — sin aditivos sintéticos, rellenos ni derivados químicos.',
  bp_prod_use_title: 'Instrucciones de Uso',
  bp_prod_overview: 'Resumen Completo de la Serie',
  bp_prod_add_cart: 'Al Carrito',

  // ── Blue Protect Rituales ──
  bp_rit_badge: '✦ Prácticas Sagradas ✦',
  bp_rit_title: 'Rituales de Protección',
  bp_rit_sub: 'Los productos Blue Protect son más poderosos cuando se aplican conscientemente como ritual — exactamente como lo hacían nuestros ancestros durante generaciones.',
  bp_rit_duration: 'Duración',
  bp_rit_level: 'Nivel',
  bp_rit_products: 'Productos Necesarios',
  bp_rit_steps: 'Paso a paso',
  bp_rit_tip: 'Consejo',
  bp_rit1_title: 'Limpieza Diaria del Aura',
  bp_rit1_sub: 'Rutina matutina preventiva',
  bp_rit1_duration: '8 minutos',
  bp_rit1_level: 'Principiantes',
  bp_rit1_tip: 'Usa este ritual cada mañana como prevención, incluso si no tienes quejas directas.',
  bp_rit2_title: 'Baño de Limpieza Espiritual',
  bp_rit2_sub: 'Reinicio energético profundo',
  bp_rit2_duration: '30–40 minutos',
  bp_rit2_level: 'Principiante',
  bp_rit2_tip: 'Realiza este ritual preferiblemente el viernes o en luna llena para máximo efecto purificador.',
  bp_rit3_title: 'Ritual de Limpieza del Hogar',
  bp_rit3_sub: 'Protege tu hogar completamente',
  bp_rit3_duration: '15–20 minutos',
  bp_rit3_level: 'Principiantes',
  bp_rit3_tip: 'Repite este ritual semanalmente, o inmediatamente después de conflictos o muchas visitas.',
  bp_rit4_title: 'Protección de los Vulnerables',
  bp_rit4_sub: 'Para niños y mujeres embarazadas',
  bp_rit4_duration: '5 minutos',
  bp_rit4_level: 'Principiantes',
  bp_rit4_tip: 'Los niños y las mujeres embarazadas son según la tradición los más vulnerables al mal de ojo. La protección regular es esencial.',

  // ── Evil Energy Hero ──
  ee_hero_badge: 'Protección Máxima',
  ee_hero_title: 'Serie Evil Energy Destroy',
  ee_hero_sub: 'Para quienes sufren ataques espirituales intensos, energías malignas persistentes o exposición repetida al mal de ojo — cuando la protección ordinaria ya no es suficiente.',
  ee_hero_pure: 'Basado en la receta de protección más poderosa de nuestros ancestros. Puro, potente, sin contaminar.',
  ee_hero_view: 'Ver Productos',
  ee_hero_discover: 'Descubrir la Fórmula',
  ee_hero_stat1: 'Productos en la Serie',
  ee_hero_stat2: 'Valoración Media',
  ee_hero_stat3: 'Reseñas de Clientes',
  ee_hero_stat4: 'Extracto de Hing Puro',

  // ── Evil Energy Ingredientes ──
  ee_ing_badge: '✦ El Ingrediente Clave ✦',
  ee_ing_title: 'El Poder del Hing',
  ee_ing_sub: 'Los seis productos de la Serie Evil Energy Destroy están construidos alrededor de un poderoso ingrediente clave: extracto puro de hing (Ferula asafoetida) — el repelente más fuerte que conoce la naturaleza.',
  ee_ing_promise_badge: 'Nuestra Promesa',
  ee_ing_promise_title: 'Hing puro. Nada más. Sin imitaciones sintéticas. Nunca.',
  ee_ing_promise_desc: 'Mientras que muchas otras marcas usan fragancias sintéticas baratas como sustituto, nosotros nos negamos. Nuestro hing se obtiene 100% puro de la raíz de la planta Ferula asafoetida — exactamente como lo usaban nuestros ancestros.',
  ee_ing_name: 'Hing (Asafétida)',
  ee_ing_latin: 'Ferula asafoetida',
  ee_ing_desc: 'El hing — también conocido como excremento del diablo o asafétida — es el repelente más poderoso en la tradición de protección surinamesa, hindustaní y del sur de Asia. El aroma agudo y penetrante del hing es capaz de ahuyentar directamente a los espíritus malignos, las intenciones negativas y el mal de ojo. Donde hay hing, el mal no puede prosperar.',
  ee_ing_origin: 'Irán, Afganistán e India — utilizado durante miles de años como agente protector sagrado en múltiples culturas del mundo',
  ee_ing_found_in: 'Presente en los 6 productos',
  ee_ing_surinamese: 'Tradición surinamesa',
  ee_ing_surinamese_text: 'En la cultura surinamesa, el hing se ha utilizado durante generaciones para proteger a los bebés y los vulnerables. Un poco de hing en el cabello o bajo la almohada de un bebé mantiene alejado el mal de ojo.',
  ee_ing_hindustani: 'Tradición hindustaní',
  ee_ing_hindustani_text: 'El hing — también conocido como "heeng" o "inguva" — se usa en rituales de protección hindustaníes para ahuyentar espíritus malignos y energías negativas. Quemar hing limpia completamente un espacio.',
  ee_ing_worldwide: 'Reconocimiento mundial',
  ee_ing_worldwide_text: 'Desde el Medio Oriente hasta Asia Central: el hing es reconocido en múltiples culturas como uno de los repelentes más poderosos que conoce la naturaleza. El solo aroma ahuyenta el mal.',

  // ── Evil Energy Rituales ──
  ee_rit_badge: '✦ Prácticas Sagradas ✦',
  ee_rit_title: 'Rituales de Protección',
  ee_rit_sub: 'Cada producto de la Serie Evil Energy Destroy tiene su propio ritual de aplicación. Combínalos para una protección completa y multicapa del cuerpo y el hogar.',
  ee_rit_duration: 'Duración',
  ee_rit_level: 'Nivel',
  ee_rit_products: 'Productos Necesarios',
  ee_rit_steps: 'Paso a paso',
  ee_rit_tip: 'Consejo',
  ee_rit1_title: 'Ritual de Baño Diario',
  ee_rit1_sub: 'Protección del cuerpo y el aura',
  ee_rit1_duration: '15–20 minutos',
  ee_rit1_level: 'Principiantes',
  ee_rit1_tip: 'Usa cada día para protección continua. Para casos graves: dos veces al día.',
  ee_rit2_title: 'Protección del Bebé',
  ee_rit2_sub: 'Seguro día y noche para tu pequeño',
  ee_rit2_duration: '2 minutos',
  ee_rit2_level: 'Principiantes',
  ee_rit2_tip: 'Repite cada día. Después de visitas de muchas personas o en entornos concurridos: aplica inmediatamente al regresar a casa.',
  ee_rit3_title: 'Ritual de Limpieza del Hogar',
  ee_rit3_sub: 'Expulsa las energías malignas de cada habitación',
  ee_rit3_duration: '20–30 minutos',
  ee_rit3_level: 'Principiantes',
  ee_rit3_tip: 'Hazlo semanalmente o inmediatamente después de visitas de personas que traen una atmósfera pesada.',
  ee_rit4_title: 'Ritual de Vela y Difusor',
  ee_rit4_sub: 'Protección continua a través del aroma y la luz',
  ee_rit4_duration: '5 minutos de preparación',
  ee_rit4_level: 'Principiantes',
  ee_rit4_tip: 'Quemar aceite de hing en el dormitorio también protege durante el sueño. Nunca usar sin supervisión.',
  ee_rit5_title: 'Fregar el Suelo',
  ee_rit5_sub: 'Construir protección desde el suelo',
  ee_rit5_duration: '20 minutos',
  ee_rit5_level: 'Principiantes',
  ee_rit5_tip: 'Fregar semanalmente con Cologne mantiene la casa continuamente protegida. Ideal como complemento al ritual de incienso.',

  // ── Evil Energy Bundle ──
  ee_bundle_badge: '✦ Combinación Recomendada ✦',
  ee_bundle_title: 'El Paquete Ritual Diario',
  ee_bundle_sub: 'Para máxima protección, combina el Jabón Evil Energy Destroy con el Cologne en un ritual de baño diario. Juntos forman un ciclo completo de limpieza energética que rompe, destruye y lleva la energía maligna.',
  ee_bundle_step1: 'Paso 1',
  ee_bundle_step2: 'Paso 2',
  ee_bundle_ritual_title: 'El Ritual de Baño Diario',
  ee_bundle_ritual_sub: 'Ciclo completo de protección paso a paso',
  ee_bundle_ritual_note: 'Detalle ritual importante',
  ee_bundle_ritual_note_desc: 'Lanza la botella hacia atrás sin mirar atrás. Darse la vuelta para mirar rompe la transferencia energética y puede reducir la protección. Realiza el ritual preferiblemente por la mañana para un día lleno de protección.',
  ee_bundle_cta_badge: 'Paquete Diario Recomendado',
  ee_bundle_cta_title: 'Paquete Jabón + Cologne',
  ee_bundle_cta_sub: 'Ambos productos juntos — completo para el ritual diario',
  ee_bundle_label: 'Paquete',
  ee_bundle_add: 'Agregar Paquete al Carrito',
  ee_bundle_all: 'Ver Todos los Productos',
  ee_bundle_pure: '100% Natural Puro',
  ee_bundle_daily: 'Uso Diario',
  ee_bundle_proven: 'Ritual Probado',
  ee_bundle_step1_title: 'Llenar el baño',
  ee_bundle_step1_desc: 'Llena el baño con agua caliente y añade un buen chorro de Evil Energy Destroy Cologne al agua del baño. Remueve con la mano tres veces en el sentido de las agujas del reloj.',
  ee_bundle_step2_title: 'Lavar el cuerpo',
  ee_bundle_step2_desc: 'Lava tu cuerpo con el Jabón Evil Energy Destroy. Deja que la mezcla de cologne y jabón fluya por todo tu cuerpo.',
  ee_bundle_step3_title: 'Recoger la mezcla',
  ee_bundle_step3_desc: 'Recoge el agua que ha fluido por tu cuerpo en una botella vacía. Esta agua ha absorbido las energías malignas.',
  ee_bundle_step4_title: 'Añadir 5 céntimos',
  ee_bundle_step4_desc: 'Añade una moneda de 5 céntimos a la botella y ciérrala bien. La moneda fortalece la transferencia de energía negativa.',
  ee_bundle_step5_title: 'Botella al mar',
  ee_bundle_step5_desc: 'Lanza la botella hacia atrás al mar — sin mirar atrás. El agua del mar lleva las energías malignas permanentemente.',

  // ── EDK Hero ──
  edk_hero_badge: 'Casos Extremos · Kit Hazlo Tú Mismo',
  edk_hero_title: '¡Evil Energy Destroy Kit Completo!',
  edk_hero_sub: 'Para los casos más graves — cuando limpiar un espacio no es suficiente y la energía maligna debe ser destruida. Un paquete completo con todo lo que necesitas.',
  edk_hero_pure: 'Incluye Blueprint profesional · Mezcla especial de incienso de hierbas · Materiales rituales completos',
  edk_hero_complete: 'Paquete completo',
  edk_hero_discover: 'Descubre Cuándo Necesitas Esto',
  edk_hero_stat1: 'Artículos en el Paquete',
  edk_hero_stat2: 'Situaciones Cubiertas',
  edk_hero_stat3: 'Natural Puro',
  edk_hero_stat4: 'Valoración Media',
  edk_hero_added: '¡Agregado al carrito!',
  edk_hero_add: 'Al Carrito',

  // ── EDK Contenidos ──
  edk_contents_badge: '✦ ¿Qué Hay en el Paquete? ✦',
  edk_contents_title: 'El Arsenal Completo',
  edk_contents_sub: 'Todo lo que necesitas para destruir las energías malignas. Cuidadosamente ensamblado por ZpiritualZ — nada más necesario, nada menos.',
  edk_contents_summary: '10 Artículos · 1 Kit Completo',
  edk_contents_summary_sub: 'Todo lo que necesitas para el ritual de destrucción',
  edk_contents_blueprint_title: 'Blueprint Incluido',
  edk_contents_blueprint_sub: 'La guía secreta — exclusiva con este paquete',
  edk_contents_blueprint_p1: 'Sin el conocimiento adecuado, los mejores materiales no sirven de nada. El Blueprint es la guía que te lleva paso a paso a través del ritual de destrucción completo. Qué orden, qué material en qué momento, qué intención estableces.',
  edk_contents_blueprint_p2: 'El Blueprint fue desarrollado exclusivamente por ZpiritualZ y solo está disponible como parte del Destroy Kit. Lo recibes inmediatamente al comprar.',
  edk_contents_pure: '100% Natural Puro',
  edk_contents_no_synth: 'Sin Aditivos Sintéticos',
  edk_contents_ancient: 'Fórmula Ancestral',
  edk_contents_guaranteed: 'Garantía ZpiritualZ',

  // ── EDK Problemas ──
  edk_prob_badge: '✦ ¿Para Quién Es Este Paquete? ✦',
  edk_prob_title: '¿Reconoces Tu Situación?',
  edk_prob_sub: 'El Destroy Kit fue desarrollado para tres situaciones específicas y graves. Lee cuál se parece más a tu situación.',
  edk_prob_symptoms: 'Señales Reconocibles',
  edk_prob_order: 'Pedir el Destroy Kit',

  // ── EDK Compra ──
  edk_purch_test_badge: '✦ Experiencias ✦',
  edk_purch_test_title: 'Lo Que Dicen Nuestros Clientes',
  edk_purch_cta_badge: '✦ Hazlo Ahora ✦',
  edk_purch_cta_title: 'Destruye La Energía Maligna Para Siempre',
  edk_purch_cta_sub: 'Deja de aceptar lo que no tienes que aceptar. Con el conocimiento y los materiales adecuados, puedes manejarlo tú mismo — hoy.',
  edk_purch_kit_name: 'Evil Energy Destroy Kit Completo',
  edk_purch_includes: 'Incluye Blueprint, Mezcla de Hierbas y Set Ritual Completo',
  edk_purch_blueprint: 'Blueprint Incluido',
  edk_purch_herbs: 'Mezcla Especial de Hierbas',
  edk_purch_shell: 'Concha Abulón + Pluma',
  edk_purch_coal: 'Carbón + Vela',
  edk_purch_added: '¡Agregado al carrito!',
  edk_purch_add: 'Al Carrito',
  edk_purch_pure: '100% Natural Puro',
  edk_purch_fast: 'Envío Rápido',
  edk_purch_worldwide: 'Envío Mundial',
  edk_purch_guarantee: 'Garantía ZpiritualZ',
  edk_purch_safe: 'Pago seguro via Stripe · tarjeta de crédito e iDEAL',

  // ── BPProducts ──
  bp_prod_in_stock_label: 'En stock',
  bp_prod_add_cart_btn: 'Al Carrito',
  bp_prod_ing_label: 'Ingredientes',
  bp_prod_use_label: 'Cómo Usar',
  bp_prod_series_label: 'Serie Blue Protect',
  bp_prod_overview_label: 'Resumen Completo de la Serie',
  bp_prod_ing_pure_note: 'Todos los ingredientes son 100% puros en origen — sin aditivos sintéticos, rellenos ni derivados químicos.',

  // ── EDKContents ──
  edk_cont_badge: '✦ ¿Qué Hay en el Paquete? ✦',
  edk_cont_title: 'El Arsenal Completo',
  edk_cont_sub: 'Todo lo que necesitas para destruir las energías malignas. Cuidadosamente ensamblado por ZpiritualZ — nada más necesario, nada menos.',
  edk_cont_summary: '10 Artículos · 1 Kit Completo',
  edk_cont_summary_sub: 'Todo lo que necesitas para el ritual de destrucción',
  edk_cont_old_price: '€99,95',
  edk_cont_price: '€79,95',
  edk_cont_blueprint_title: 'Blueprint Incluido',
  edk_cont_blueprint_sub: 'La guía secreta — exclusiva con este paquete',
  edk_cont_blueprint_p1: 'Sin el conocimiento adecuado, los mejores materiales no sirven de nada. El Blueprint es la guía que te lleva paso a paso a través del ritual de destrucción completo. Qué orden, qué material en qué momento, qué intención estableces.',
  edk_cont_blueprint_p2: 'El Blueprint fue desarrollado exclusivamente por ZpiritualZ y solo está disponible como parte del Destroy Kit. Lo recibes inmediatamente al comprar.',
  edk_cont_pure: '100% Natural Puro',
  edk_cont_no_synth: 'Sin Aditivos Sintéticos',
  edk_cont_ancient: 'Fórmula Ancestral',
  edk_cont_guaranteed: 'Garantía ZpiritualZ',
  edk_cont_item1_name: 'Blueprint Exclusivo',
  edk_cont_item1_desc: 'Guía paso a paso de ZpiritualZ para el ritual de destrucción completo. Qué pasos, en qué orden, con qué material. Nada dejado al azar.',
  edk_cont_item1_tag: 'Incluido',
  edk_cont_item2_name: 'Mezcla Especial de Incienso de Hierbas',
  edk_cont_item2_desc: 'Nuestra mezcla exclusiva de extractos de salvia, ghandak, pimienta, hing y lobhan. Una fórmula propia confiable con eficacia probada — particularmente poderosa para destruir energías malignas.',
  edk_cont_item2_tag: 'Mezcla Propia',
  edk_cont_item3_name: 'Extractos de Salvia',
  edk_cont_item3_desc: 'Salvia pura seca — la hierba purificadora más utilizada en el mundo. Limpia el aura y el espacio de toda energía negativa tras la combustión.',
  edk_cont_item3_tag: 'Hierba',
  edk_cont_item4_name: 'Ghandak (Azufre)',
  edk_cont_item4_desc: 'Uno de los agentes protectores más antiguos y poderosos. El ghandak destruye energías malignas persistentes y entidades que sobreviven a otros agentes purificadores.',
  edk_cont_item4_tag: 'Destructivo',
  edk_cont_item5_name: 'Pimienta y Hing',
  edk_cont_item5_desc: 'La pimienta negra se combina con el hing (asafétida) para una doble línea de protección. Juntos forman una muralla energética que repele y destruye las influencias negativas.',
  edk_cont_item5_tag: 'Doble Poder',
  edk_cont_item6_name: 'Lobhan (Benjuí)',
  edk_cont_item6_desc: 'Resina purificadora árabe-surinamesa tradicional. El lobhan limpia profundamente a nivel espiritual y protege el espacio tras el ritual de purificación.',
  edk_cont_item6_tag: 'Resina',
  edk_cont_item7_name: 'Concha Abulón',
  edk_cont_item7_desc: 'El cuenco sagrado para quemar tu incienso. La concha abulón protege tus manos y amplifica la energía del humo que asciende durante el ritual.',
  edk_cont_item7_tag: 'Ritual',
  edk_cont_item8_name: 'Pluma de Búho',
  edk_cont_item8_desc: 'Un poderoso instrumento ritual. La pluma de búho extiende el humo sagrado por el espacio y se considera un poderoso símbolo protector en muchas tradiciones espirituales.',
  edk_cont_item8_tag: 'Ritual',
  edk_cont_item9_name: 'Carbón',
  edk_cont_item9_desc: 'Carbón especial para quemar tu mezcla de incienso. El carbón garantiza una combustión uniforme y duradera para que el poder de las hierbas se libere completamente.',
  edk_cont_item9_tag: 'Combustión',
  edk_cont_item10_name: 'Vela Blanca',
  edk_cont_item10_desc: 'Vela blanca pura para fortalecer la intención del ritual y simbolizar la luz frente a la oscuridad. Ilumina tu ritual y atrae energía positiva.',
  edk_cont_item10_tag: 'Luz',

  // ── EDKProblems ──
  edk_prob_badge: '✦ ¿Para Quién Es Este Paquete? ✦',
  edk_prob_title: '¿Reconoces',
  edk_prob_title2: 'Tu Situación?',
  edk_prob_sub: 'El Destroy Kit fue desarrollado para tres situaciones específicas y graves. Lee cuál se parece más a tu situación.',
  edk_prob_symptoms_label: 'Señales Reconocibles',
  edk_prob_order_btn: 'Pedir el Destroy Kit — €79,95',
  edk_prob1_tag: 'Bebé y Habitaciones Infantiles',
  edk_prob1_title: 'Tu Bebé Se Despierta Asustado Cada Noche',
  edk_prob1_sub: 'Inquietud, miedo y llanto sin razón',
  edk_prob1_p1: 'Empezó con una noche. Luego dos. Luego el mismo patrón cada noche — tu pequeño llora, se despierta asustado, mira fijamente a una esquina de la habitación como si viera algo allí. Lo has intentado todo. Nuevo chupete, música suave, más abrazos. Nada ayuda.',
  edk_prob1_p2: 'Lo que la mayoría de los padres no saben: los bebés y los niños pequeños son extremadamente sensibles a las energías. Sienten lo que los adultos ya no pueden sentir. Cuando un bebé se despierta asustado repetidamente, llora o no quiere dormir en una habitación determinada, eso es en muchas tradiciones una señal de que el espacio está cargado negativamente.',
  edk_prob1_p3: 'El Evil Energy Destroy Kit está especialmente diseñado para estos casos. La mezcla de incienso de hierbas con salvia, ghandak y hing limpia la habitación a nivel energético. El Blueprint explica paso a paso cómo liberar completamente la habitación — para que tu pequeño pueda finalmente dormir tranquilo de nuevo.',
  edk_prob1_s1: 'El bebé se despierta asustado repetidamente a la misma hora',
  edk_prob1_s2: 'Mira con miedo a la misma esquina o lugar de la habitación',
  edk_prob1_s3: 'Sueño inquieto sin causa médica',
  edk_prob1_s4: 'Comportamiento repentinamente cambiado tras la mudanza',
  edk_prob2_tag: 'Nueva Vivienda o Negocio',
  edk_prob2_title: 'Un Nuevo Comienzo Merece un Borrón y Cuenta Nueva',
  edk_prob2_sub: 'Destruir la energía negativa del pasado',
  edk_prob2_p1: 'Todos los que vivieron o trabajaron en esa casa o negocio antes que tú han dejado su energía. Peleas. Tristeza. Celos. Preocupaciones económicas. Fracaso. Esa energía se adhiere a las paredes, los suelos, los umbrales — y espera al siguiente ocupante. A ti.',
  edk_prob2_p2: 'En muchas culturas, limpiar un nuevo espacio es un ritual sagrado antes de mudarse. No sin razón. Cuando comienzas un nuevo negocio en un espacio donde un empresario anterior quebró, asumes su legado energético. Cuando te mudas a una casa donde reinaban las tensiones, a veces lo sientes de inmediato — una sensación pesada, sin energía, las cosas no funcionan.',
  edk_prob2_p3: 'El Destroy Kit te da todo lo que necesitas para destruir completamente esa energía antigua y recargar tu espacio. La concha abulón, la pluma de búho y la mezcla completa de incienso proporcionan juntos una limpieza profunda del espacio. El Blueprint explica el ritual de la A a la Z.',
  edk_prob2_s1: 'Sensación pesada persistente en el nuevo espacio',
  edk_prob2_s2: 'Negocios o proyectos que simplemente no despegan',
  edk_prob2_s3: 'Contratiempos constantes desde el momento de mudarse',
  edk_prob2_s4: 'Sensación de que la energía del ocupante anterior todavía está allí',
  edk_prob3_tag: 'Presencia de una Entidad',
  edk_prob3_title: 'No Estás Solo — Y Lo Sabes',
  edk_prob3_sub: 'Para quienes perciben una presencia',
  edk_prob3_p1: 'Empieza sutilmente. Una sensación de ser observado. Sombras en el rabillo del ojo. Sonidos que no puedes explicar. Te despiertas a la misma hora en medio de la noche y sientes que algo está presente en la habitación. No dices nada porque tienes miedo de que la gente no te crea.',
  edk_prob3_p2: 'Pero sabes lo que sientes. Y contrariamente a lo que muchos piensan, la presencia de una entidad — ya sea un alma inquieta, un djinn u otra fuerza negativa — es algo que puede abordarse con el conocimiento y los medios adecuados. No tienes que aceptarlo.',
  edk_prob3_p3: 'El Evil Energy Destroy Kit en estas situaciones es más que un agente purificador — es un arma. La combinación de carbón, ghandak, salvia y lobhan en la mezcla especial ha demostrado ser eficaz a través de siglos de uso para ahuyentar presencias. La vela blanca y la pluma de búho fortalecen la intención. El Blueprint te guía de forma segura a través del ritual de destrucción completo.',
  edk_prob3_s1: 'Despertarse a horas fijas con sensación de presencia',
  edk_prob3_s2: 'Sombras o movimiento en el rabillo del ojo',
  edk_prob3_s3: 'Sensación repentina de frío en ciertos espacios',
  edk_prob3_s4: 'Animales que reaccionan a una presencia invisible',

  // ── EDKPurchase ──
  edk_purch_test_badge: '✦ Experiencias ✦',
  edk_purch_test_title: 'Lo Que Dicen',
  edk_purch_test_title2: 'Nuestros Clientes',
  edk_purch_t1_name: 'Sharona K.',
  edk_purch_t1_text: 'Mi bebé llevaba semanas sin dormir seguido. Después del ritual en la habitación del bebé con este kit, esa misma noche ya estaba más tranquilo. Lloré de alivio.',
  edk_purch_t1_sit: 'Habitación del Bebé',
  edk_purch_t2_name: 'Aziz M.',
  edk_purch_t2_text: 'Habíamos abierto un nuevo negocio en un lugar donde tres empresas habían quebrado anteriormente. Después del ritual del Destroy Kit finalmente estamos obteniendo ganancias.',
  edk_purch_t2_sit: 'Nuevo Negocio',
  edk_purch_t3_name: 'Leila V.',
  edk_purch_t3_text: 'Llevaba meses sin atreverme a dormir sola en mi dormitorio. Después del ritual de destrucción la sensación de presencia ha desaparecido completamente.',
  edk_purch_t3_sit: 'Presencia',
  edk_purch_t4_name: 'Rania H.',
  edk_purch_t4_text: 'El Blueprint lo hace tan fácil. Nunca pensé que podría hacer esto yo sola. Funcionó perfectamente la primera vez.',
  edk_purch_t4_sit: 'Nueva Vivienda',
  edk_purch_cta_badge: '✦ Hazlo Ahora ✦',
  edk_purch_cta_title: 'Destruye La Energía',
  edk_purch_cta_title2: 'Maligna Para Siempre',
  edk_purch_cta_sub: 'Deja de aceptar lo que no tienes que aceptar. Con el conocimiento y los materiales adecuados, puedes manejarlo tú mismo — hoy.',
  edk_purch_kit_label: 'Evil Energy Destroy Kit Completo',
  edk_purch_old_price: '€99,95',
  edk_purch_includes_label: 'Incluye Blueprint, Mezcla de Hierbas y Set Ritual Completo',
  edk_purch_added_btn: '¡Agregado al carrito!',
  edk_purch_add_btn: 'Al Carrito — €79,95',
  edk_purch_safe_pay: 'Pago seguro via Stripe · tarjeta de crédito e iDEAL',
  edk_purch_feat1: 'Blueprint Incluido',
  edk_purch_feat2: 'Mezcla Especial de Hierbas',
  edk_purch_feat3: 'Concha Abulón + Pluma',
  edk_purch_feat4: 'Carbón + Vela',
  edk_purch_g1: '100% Natural Puro',
  edk_purch_g2: 'Envío Rápido',
  edk_purch_g3: 'Envío Mundial',
  edk_purch_g4: 'Garantía ZpiritualZ',

  // ── Blue Protect Pasos de Rituales ──
  bp_rit1_s1: 'Comienza tu día con un baño o ducha caliente. Usa el Blue Protect Soap con movimientos lentos y ascendentes de pie a cabeza — esto sigue la dirección del flujo de energía.',
  bp_rit1_s2: 'Deja que el jabón se absorba durante 1–2 minutos mientras visualizas una luz azul clara que te rodea y protege completamente.',
  bp_rit1_s3: 'Enjuágate. Sécate suavemente y rocía el Blue Protect Spray 4× alrededor de tu cuerpo en un movimiento circular.',
  bp_rit1_s4: 'Rocía también en muñecas y cuello. Cierra los ojos y di o piensa conscientemente: "Estoy protegido/a. La negatividad no tiene acceso a mi aura."',

  bp_rit2_s1: 'Llena un baño caliente y añade 3 cucharadas de Blue Protect Powder. Remueve con tu mano tres veces en el sentido de las agujas del reloj y pronuncia una intención protectora.',
  bp_rit2_s2: 'Deja que una Blue Protect Ball se disuelva en el agua del baño — el extracto azul se disuelve lentamente y fortalece el efecto purificador del baño.',
  bp_rit2_s3: 'Métete en el baño y relájate. Deja que el agua azul actúe durante 20–25 minutos. Respira consciente y tranquilamente.',
  bp_rit2_s4: 'Sumerge tu cabeza tres veces completamente. En cada momento, imagina cómo la energía negativa se aleja completamente de ti.',
  bp_rit2_s5: 'Sal del baño sin enjuagarte con agua limpia — mantén la capa protectora del polvo en tu piel.',

  bp_rit3_s1: 'Comienza en la puerta principal. Esparce una línea fina de Blue Protect Powder frente al umbral, de izquierda a derecha — esto crea una barrera protectora.',
  bp_rit3_s2: 'Camina por cada habitación en el sentido de las agujas del reloj. Esparce una pequeña cantidad de polvo en cada esquina de la habitación.',
  bp_rit3_s3: 'Rocía el Blue Protect Spray en cada habitación: 2–3 sprays hacia arriba, hacia el techo.',
  bp_rit3_s4: 'Cierra el ritual en la puerta principal con una capa extra de polvo y declara conscientemente que las energías malignas ya no son bienvenidas en tu hogar.',

  bp_rit4_s1: 'Aplica una pequeña cantidad de Blue Protect Powder en la frente del niño o la mujer embarazada — esta es la marca de protección tradicional.',
  bp_rit4_s2: 'Aplica también en muñecas y tobillos. Estos son los puntos energéticamente más sensibles del cuerpo.',
  bp_rit4_s3: 'Rocía ligeramente el Blue Protect Spray alrededor de la persona — mantén el spray a distancia de un brazo y rocía de cabeza a pies.',
  bp_rit4_s4: 'Repite cada mañana antes de salir o después de visitas de muchas personas. Repite siempre después de visitar lugares concurridos.',

  // ── Evil Energy Pasos de Rituales ──
  ee_rit1_s1: 'Llena el baño con agua caliente y añade un buen chorro de Evil Energy Destroy Cologne al agua del baño. Remueve con tu mano tres veces en el sentido de las agujas del reloj.',
  ee_rit1_s2: 'Entra en el baño y deja que el agua se absorba durante 5 minutos mientras respiras tranquilamente y estableces tu intención: protección para el día que viene.',
  ee_rit1_s3: 'Lava tu cuerpo lentamente con el Evil Energy Destroy Jabón — de pie a cabeza, con movimientos ascendentes. Visualiza cómo el hing forma un escudo repelente alrededor de tu aura.',
  ee_rit1_s4: 'Deja que el jabón se absorba durante 2 minutos. Enjuágate. Sécate sin prisa. La protección permanece activa todo el día.',

  ee_rit2_s1: 'Toma una cantidad de Baby Hing Pasta del tamaño de un guisante en tu dedo.',
  ee_rit2_s2: 'Aplica suavemente la pasta en el cabello del bebé, cerca del cráneo en la parte posterior de la cabeza. Esta es la marca de protección tradicional.',
  ee_rit2_s3: 'Alternativa: haz una pequeña bola con la pasta y colócala bajo la almohada del bebé para protección durante el sueño.',
  ee_rit2_s4: 'Reemplaza la pasta diariamente con pasta fresca para una eficacia óptima. No usar en la cara ni en piel abierta.',

  ee_rit3_s1: 'Abre todas las ventanas y puertas. Comienza en la habitación más alejada de la casa.',
  ee_rit3_s2: 'Coloca una cucharadita de Hing Poeder en carbón al rojo vivo o en un quemador de incienso. Deja que el humo llene la habitación mientras la recorres.',
  ee_rit3_s3: 'Muévete de habitación en habitación hacia la puerta principal — siempre hacia adelante, nunca hacia atrás. Deja que el humo se asiente en cada habitación por un momento.',
  ee_rit3_s4: 'Termina en la puerta principal. Rocía el Evil Energy Destroy Spray 3× en cada esquina del pasillo y 2× frente al umbral.',
  ee_rit3_s5: 'Cierra la puerta principal y deja la casa cerrada con humo durante 15 minutos para plena efectividad. Luego ventila bien.',

  ee_rit4_s1: 'Aplica el Evil Energy Destroy Hing Olie sobre una vela negra o blanca — de abajo hacia arriba. Esto carga la vela con intención protectora.',
  ee_rit4_s2: 'Establece tu intención: habla o piensa conscientemente sobre aquello de lo que quieres estar protegido/a mientras frotas la vela.',
  ee_rit4_s3: 'Enciende la vela en un lugar seguro. Mientras la vela arde, el aroma del hing extiende protección por el espacio.',
  ee_rit4_s4: 'Alternativa: añade 4–5 gotas de aceite a un difusor con agua caliente. Deja que actúe todo el día o la noche como protección continua.',

  ee_rit5_s1: 'Añade 3 goteros de Evil Energy Destroy Cologne al cubo de fregar con agua. Remueve bien.',
  ee_rit5_s2: 'Comienza en la habitación más alejada de la casa. Friega en líneas rectas, siempre hacia la salida.',
  ee_rit5_s3: 'Friega cada habitación de atrás hacia adelante. Muévete siempre hacia la puerta principal — así mueves literalmente la energía negativa fuera de la casa.',
  ee_rit5_s4: 'Termina en la puerta principal. Friega el umbral como último paso. Deja que el suelo se seque sin enjuagar.',

  // ── Común ──
  common_loading: 'Cargando...',
  common_error: 'Algo salió mal. Por favor inténtalo de nuevo.',
  common_required: 'obligatorio',
  common_mostChosen: 'Más Popular',
  common_selected: 'Seleccionado',
  common_bestseller: 'Más Vendido',
  common_new: 'Nuevo',
  common_exclusive: 'Exclusivo',
  common_sale: 'Oferta',
  common_onceOnly: 'único',
  common_pay_safe: 'Pago seguro via Stripe',
  common_reviews: 'reseñas',
  common_products: 'productos',
};

export default es;
